import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class ToCorrectFileDataLengthBaseValueConverter {
    toView(value) {
        if (ObjectHelper.IsNotNullAndUndefined(value)) {
            let i18n = new I18N();
            let locale = i18n.getLocale().toLowerCase().substring(0, 2);

            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (value == 0) return '0 Byte';
            var i = parseInt(Math.floor(Math.log(value) / Math.log(1024)).toString());
            return Math.round(value / Math.pow(1024, i)) + ' ' + sizes[i];            
        }
        return value;
    }
}